export async function loadLinksInteraction(engine, refresh = true) {
    await engine.addInteractor("particlesLinks", async (container) => {
        const { Linker } = await import("./Linker.js");
        return new Linker(container);
    }, refresh);
}
